import React from 'react';

import RecipesGallery from '../components/RecipeGallery';

function HomePage() {
  return (
    <div>
      <RecipesGallery />
    </div>
  );
}

export default HomePage;